<template>
  <div class="flex flex-col gap-y-3 rounded-3xl bg-white ring-1 ring-gray-200 shadow-soft p-6">
    <div class="flex items-start justify-between gap-x-3">
      <atomic-icon-square :icon-name="iconName" />

      <atomic-badge
        v-if="badge"
        :label="badge"
      />
    </div>

    <h3 class="text-lg font-display font-semibold tracking-tight text-gray-900">
      {{ title }}
    </h3>

    <p class="text-sm/6 text-gray-600">
      {{ description }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { IconCardProps } from 'types/section'

defineProps<IconCardProps>()
</script>
